// Various utils that aren't specific to a single module.


CAF = window.CAF || {}

CAF.SETTINGS = window.CAF.SETTINGS || {};

CAF.SETTINGS.maxMobile = 683;

CAF.UTILS = {

	areWeMobile : function() {
		return $(window).width() <=  CAF.SETTINGS.maxMobile;
	},

	//http://stackoverflow.com/a/10073788
	lpad : function ( n, width, z ) {
		z = z || '0';
		n = n + '';
		return n.length >= width ? n : new Array( width - n.length + 1 ).join( z ) + n;
	},

	shuffleArray : function ( array ) {
		var j, x, i;
		for ( i = array.length; i; i -= 1 ) {
			j = Math.floor( Math.random() * i );
			x = array[ i - 1 ];
			array[ i - 1 ] = array[ j ];
			array[ j ] = x;
		}
	},

	// Extracts a YouTube ID from a URL and even an iFrame code
	youTubeGetID : function ( url ) {
		// from https://gist.github.com/takien/4077195
		var ID = '';
		url = url.replace( /(>|<)/gi, '' ).split( /(vi\/|v=|\/v\/|youtu\.be\/|\/embed\/)/ );
		if ( url[ 2 ] !== undefined ) {
			ID = url[ 2 ].split( /[^0-9a-z_\-]/i );
			ID = ID[ 0 ];
		}
		else {
			ID = url;
		}
		return ID;
	},
	makeSafeForCss: function(text) {
		return text.replace(/[^a-z0-9]/g, function(s) {
			var c = s.charCodeAt(0);
			if (c == 32) return '-';
			if (c >= 65 && c <= 90) return s.toLowerCase();
			// return '__' + ('000' + c.toString(16)).slice(-4);
			return '-';
		});
	}


};

